import { render } from "./productionAudit.vue?vue&type=template&id=3fff5a82&scoped=true"
import script from "./productionAudit.vue?vue&type=script&lang=js"
export * from "./productionAudit.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fff5a82"]])

export default __exports__